export default "<router-outlet></router-outlet>\r\n<ng-http-loader> </ng-http-loader>\r\n<div (window:beforeunload)=\"clearAllData()\"></div>";